import alignElements from './align-elements';

export default function vAlign(elements, rect, alignment) {
    alignElements(elements, rect, alignment, "y", "height");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/alignment/v-align.js
// module id = 1844
// module chunks = 29